import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

import Divider from "@material-ui/core/Divider";
import {getTranslation} from "../../helpers/get-translation";
import SettingsOptionButton from "./settings-option-button"
import UploadAvatar, {AVATAR_INPUT_ID} from "./upload-avatar";

function SettingsOptionLink(props) {
	return (
		<div>
			<a
                href={props.href}
                target="_blank"
                style={{color: "rgba(0, 0, 0, 0.87)", textDecoration: "none"}}>
				<SettingsOptionButton {...props} />
			</a>
		</div>
	);
}

SettingsOptionLink.propTypes = {
	name: PropTypes.string.isRequired,
	img: PropTypes.string.isRequired,
	href: PropTypes.string.isRequired,
	isLast: PropTypes.bool,
	hasCircleImage: PropTypes.bool,
};

export default SettingsOptionLink;
